"use strict";

import "./help-parameterization-dialog.scss";

class HelpParameterizationDialogCtrl {
    constructor($mdDialog, $state, locals) {
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.locals = locals;
    }
    $onInit() {
        this.tabSelected = 0;
        this.tabInformations = true;
    }
    onClose() {
        this.$mdDialog.hide();
    }
}

angular.module("nucont.shared").controller("HelpParameterizationDialogCtrl", [
    "$mdDialog",
    "$state",
    "locals",
    HelpParameterizationDialogCtrl
]);
